import { Box, Button, ButtonGroup, Divider, Grid, Typography } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  navigate,
  sendGetRequest,
  shortenUrl,
  getDayOfWeek,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";



const AppSettings = () => {
  let [music, setMusic] = useState({});
  let [challenge, setChallenge] = useState({});

  const btnGroupOptions = [
    { label: "Background Music", destination: `${AppRoutes.appSettings}/${AppRoutes.backgroundMusics}` },
    { label: "Daily Challenges", destination: `${AppRoutes.appSettings}/${AppRoutes.challenges}` }
  ];

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });
  useEffect(() => {
    setStatus({ ...{ loading: true } })
    Promise.all([
        sendGetRequest("music/background"),
        sendGetRequest(`challenges?day=${getDayOfWeek()}`)
      ]).then(response => {
        setStatus({ ...{ loading: false } })
        setMusic(response[0]);
        setChallenge(response[1]);
      })
    return () => {};
    // eslint-disable-next-line
  }, []);


  return (
    <EditPage
      title={"Settings"}
      status={status}
      showBtn={false}
      validated={false}
      createNewElement={
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <ButtonGroup size="large" aria-label="large button group">
            {btnGroupOptions.map((btn) => {
              return (
                <Button
                  key={btn.destination}
                  onClick={() => navigate(
                    `${btn.destination}`,
                    true
                  )}
                >
                  {btn.label}
                </Button>
              );
            })}
          </ButtonGroup>
          
        </Box>
      }
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          navigate(`${AppRoutes.payments}`, true)
        }
      }}
    >
      {music && (<Grid container sx={{ px: 5 }}>
        <Grid item xs={12} xl={12}>
          <Typography variant="h6" component="h6" color="text.disabled">
            App's Background Music
          </Typography>
          <Divider sx={{mt: 2}}></Divider>
        </Grid>

        {!music.url && (<Grid item xs={12} sx={{mt: 4}}>
          <Typography variant="body1" component="h6">
            Add background background music to your app
          </Typography>
        </Grid>)}

       <Grid container direction="row" alignContent={"space-between"} justifyContent={"space-between"}>
          {music.url && (<Grid item md={7} xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {shortenUrl(music.url)}
            </Typography>
          </Grid>)}

          {music.url && (<Grid item md={4} xs={12} sx={{ pt: 4 }}>
            <audio controls sx={{ width: "100px !important" }}>
              <source src={music.url} type="audio/ogg" />
            </audio>
          </Grid>)}
       </Grid>
      </Grid>)}

       {challenge && (<Grid container sx={{ px: 5,pt: 8 }}>
        <Grid item xs={12} xl={12}>
          <Typography variant="h6" component="h6" color="text.disabled">
            Today's Challenge
          </Typography>
          <Divider sx={{mt: 2}}></Divider>
        </Grid>

        

       <Grid container direction="column" alignContent={"space-between"} justifyContent={"space-between"}>
          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.title}
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.videoPlayed} Videos to play
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.musicListened} Songs to listen
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.booksRead} Books to read
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.gamesPlayed} Games to play
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ pt: 5 }}>
            <Typography variant="body1" component="a" >
              {challenge.timeSpent} minutes to spend
            </Typography>
          </Grid>
       </Grid>
      </Grid>)}


    </EditPage>
  );
};

export default AppSettings;